module.exports = __webpack_public_path__ + "static/media/GeekBrainsLogo.1f5ac9e9.jpg";